<script type="text/javascript" src="./w3color.js"/>

<div class="panel">
    <div class="panel-top">
        <div class="panel-layers">
            <div class="instruct"/>
            <div class="choose-layer">
                <div class="layers">
                    <label class="layer background-layer" for="left-background-radio" data-source-id="left-background-radio">
                        <input
                            checked=(state.selectedRadioId == "left-background-radio")
                            type="radio"
                            id="left-background-radio"
                            name="layer"
                        >
                        <div class="layer-content">
                            <div class="layer-details">
                                <span>[左侧背景]</span><span#left-background-radio-name>${state.map.get("left-background-name")}</span>
                                <span style="display: flex;">${state.map.get("left-background-hex")}   ${state.map.get("left-background-rgb")}</span>
                            </div>
                        </div>
                    </label>

                    <label class="layer movable-layer" for="left-movable-radio" data-source-id="left-movable-radio">
                        <input checked=(state.selectedRadioId == "left-movable-radio") type="radio" id="left-movable-radio" name="layer">
                        <div class="layer-content">
                            <div class="layer-details">
                                <span>[左侧浮动可调整图层]</span><span#left-movable-radio-name>${state.map.get("left-movable-name")}</span>
                                <span style="display: flex;">${state.map.get("left-movable-hex")}   ${state.map.get("left-movable-rgb")}</span>
                            </div>
                        </div>
                    </label>

                    <label class="layer text-layer" for="left-text-radio" data-source-id="left-text-radio">
                        <input checked=(state.selectedRadioId == "left-text-radio") type="radio" id="left-text-radio" name="layer">
                        <div class="layer-content">
                            <div class="layer-details">
                                <span>[左侧文字]</span><span#left-text-radio-name>${state.map.get("left-text-name")}</span>
                                <span style="display: flex;">${state.map.get("left-text-hex")}   ${state.map.get("left-text-rgb")}</span>
                            </div>
                        </div>
                    </label>

                    <div class="layer-no-border">
                        <div><button onClick("setText")>设置左侧浮动图层文字和位置</button></div>
                        <div><button onClick("resetAll")>重置页面所有设置</button></div>
                    </div>

                    <label class="layer background-layer" for="right-background-radio" data-source-id="right-background-radio">
                        <input
                            checked=(state.selectedRadioId == "right-background-radio")
                            type="radio"
                            id="right-background-radio"
                            name="layer"
                        >
                        <div class="layer-content">
                            <div class="layer-details">
                                <span>[右侧背景]</span><span#right-background-radio-name>${state.map.get("right-background-name")}</span>
                                <span style="display: flex;">${state.map.get("right-background-hex")}   ${state.map.get("right-background-rgb")}</span>
                            </div>
                        </div>
                    </label>

                    <label class="layer text-layer" for="right-text-radio" data-source-id="right-text-radio">
                        <input checked=(state.selectedRadioId == "right-text-radio") type="radio" id="right-text-radio" name="layer">
                        <div class="layer-content">
                            <div class="layer-details">
                                <span>[右侧文字]</span><span#right-text-radio-name>${state.map.get("right-text-name")}</span>
                                <span style="display: flex;">${state.map.get("right-text-hex")}   ${state.map.get("right-text-rgb")}</span>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
        <div class="panel-color"/>
    </div>
    <div class="panel-bottom">
        <div class="left-background" id="left-background" style=`background-color: ${state.map.get("left-background-hex")}`>
            <!-- Draggable DIV -->
                <for|item, i| of=state.movableList>
                    <div class="left-movable" data-movable-index=i style=`background-color: ${state.map.get("left-movable-hex")}; color: ${state.map.get("left-text-hex")}; top: ${item.top}px; left: ${item.left}px; width: ${item.width}px; height: ${item.height}px; cursor: ${item.cursor}; text-align: ${state.textPosition}; border: ${state.map.get("left-movable-border-style")}`>${state.leftMovableText}</div>
                </for>
            <div class="controllers">
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("C")
                        min="0"
                        max="100"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-C"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: cyan;">C</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("M")
                        min="0"
                        max="100"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-M"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: magenta;">M</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("Y")
                        min="0"
                        max="100"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-Y"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: yellow;">Y</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("K")
                        min="0"
                        max="100"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-K"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: black;">K</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("R")
                        min="0"
                        max="255"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-R"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: red;">R</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("G")
                        min="0"
                        max="255"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-G"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: green;">G</div>
                </div>
                <div class="control">
                    <input
                        type="number"
                        value=state.map.get("B")
                        min="0"
                        max="255"
                        maxlength="3"
                        inputmode="numeric"
                        name="number"
                        id="stepper-B"
                        required
                        pattern="[0-9]{1,3}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        onChange("updateColorByController")
                    >
                    <div style="color: blue;">B</div>
                </div>
            </div>
            <div>
            </div>
        </div>
        <div#right-background class="color-list" style=`background-color: ${state.map.get("right-background-hex")}; color: ${state.map.get("right-text-hex")}`>
            <div class="solar_term Common">
                <h2>常用</h2>
                <div class="colors">

                    <div
                        class="color"
                        data-hex-text="#FFFFFF" data-cmyk-text="CMYK(0,0,0,0)" 
                        style="background-color: rgb(255, 255, 255); border: 1px solid;"
                    >
                        <h3 class="color__name" style=`color:${state.map.get("right-text-hex")}`>
                            白色
                        </h3>
                        <div class="color__hex">
                            #FFFFFF
                        </div>
                        <div class="color__rgb">
                            RGB(255, 255, 255)
                        </div>
                        <div class="color__cmyk">
                            CMYK(0,0,0,0)
                        </div>
                    </div>
                    <div
                        class="color"
                        data-hex-text="#000000" data-cmyk-text="CMYK(100,100,100,100)" 
                        style="background-color: rgb(0, 0, 0); border: 1px solid;"
                    >
                        <h3 class="color__name" style=`color:${state.map.get("right-text-hex")}`>
                            黑色
                        </h3>
                        <div class="color__hex">
                            #000000
                        </div>
                        <div class="color__rgb">
                            RGB(0, 0, 0)
                        </div>
                        <div class="color__cmyk">
                            CMYK(100,100,100,100)
                        </div>
                    </div>
                    <div
                        class="free_color"
                        data-hex-text="#FFFFFF" data-cmyk-text="CMYK(0,0,0,0)" 
                        style="background-color: rgb(255, 255, 255);"
                    >
                        <h3 class="color__name">
                            自由选择：
                            <input type="color" id="free_color_id" name="head" onChange("updateFreeColor")/>
                        </h3>
                        <div class="color__hex">
                            #FFFFFF
                        </div>
                        <div class="color__rgb">
                            RGB(255, 255, 255)
                        </div>
                        <div class="color__cmyk">
                            CMYK(0,0,0,0)
                        </div>
                    </div>
                </div>
            </div>
            <solar-terms ...state />
        </div>
    </div>
</div>
<ebay-confirm-dialog
    confirm-text='确定'
    rejectText='取消'
    open=state.openTextDialog
    on-reject('closeDialog')
    on-confirm('saveDialog')
>
    <@header>请输入要展示在左侧浮动图层中的文字：</@header>
    <textarea id="left-text-input-panel-id" rows="4" cols="50" style=`text-align: ${state.textPosition}`>${state.leftMovableText}</textarea>
    <div.confirmDialog style="display: grid; grid-template-columns: 1fr 1fr 1fr;">
        <div><button onClick("setTextToLeft")>左</button></div>
        <div><button onClick("setTextToMiddle")>中</button></div>
        <div><button onClick("setTextToRight")>右</button></div>
    </div>
    <div>
        是否显示边框？
        <input type="radio" id="border-show-radio" name="border" value="show" checked=(state.map.get("left-movable-border-style") != "0px") on-change("setBorder", "show")>
        <label for="border-show-radio">显示</label>
        <input type="radio" id="border-hide-radio" name="border" value="hide" checked=(state.map.get("left-movable-border-style") == "0px") on-change("setBorder", "hide")>
        <label for="border-hide-radio">隐藏</label>
    </div>
</ebay-confirm-dialog>
<ebay-snackbar-dialog
    open=state.openSnackBarDialog
    on-close("handleClose")
    on-open("emit", "open")
    ...input
>
    ${state.msg}
</ebay-snackbar-dialog>